import { render, staticRenderFns } from "./ExperiencePricePeriods.vue?vue&type=template&id=00c6ede4&scoped=true"
import script from "./ExperiencePricePeriods.vue?vue&type=script&lang=js"
export * from "./ExperiencePricePeriods.vue?vue&type=script&lang=js"
import style0 from "./ExperiencePricePeriods.vue?vue&type=style&index=0&id=00c6ede4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6ede4",
  null
  
)

export default component.exports